import { useEffect, useRef, useState } from 'react';

export const useCheckStage = () => {
  const stageRefs = useRef<(HTMLParagraphElement | null)[]>([]);
  const [currentStage, setCurrentStage] = useState(1);

  const handleScroll = (containerRef: any) => {
    if (containerRef) {
      const containerTop = containerRef.getBoundingClientRect().top;
      let found = false;

      stageRefs.current.forEach((ref, index) => {
        if (ref) {
          const rect = ref.getBoundingClientRect();
          if (rect.top - 15 <= containerTop) {
            setCurrentStage(index + 1);
            found = true;
          }
        }
      });

      if (!found) {
        setCurrentStage(1);
      }
    }
  };

  useEffect(() => {
    const container = document.querySelector('[data-scroll]');
    container?.addEventListener('scroll', () => handleScroll(container));
    return () => {
      container?.removeEventListener('scroll', () => handleScroll(container));
    };
  }, []);

  return { stageRefs, currentStage };
};
